// ABOUTME: Context and hook shared by the parts of CAccordion (open state and style)
// ABOUTME: The provider lives in AccordionProvider.tsx; this file has no components

import type { Dispatch, SetStateAction } from "react"
import { createContext, useContext } from "react"

export interface AccordionContextValue {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  type: "flush" | "open" | "collapse"
}

export const AccordionContext = createContext<AccordionContextValue | undefined>(undefined)

function useAccordionContext() {
  const context = useContext(AccordionContext)
  if (context === undefined) {
    throw new Error("useCounterContext must be used within a CounterProvider")
  }
  return context
}

export { useAccordionContext }
